export default __webpack_public_path__ + "static/media/package3.6fca2f33.jpg";